/**
 * Interface for consolidated admin tenant information
 * This data is stored encrypted in localStorage for security
 */
export interface SecureAdminTenantInfo {
  tenantId: string;
  userId: string;
  userEmail: string;
  userRole: string;
  /** Timestamp when this data was stored for cache invalidation */
  storedAt: number;
}
